<template>
  <div v-show="salons.length !== 0">
    <div class="fw-medium fs-20">
      Наличие в салонах ОРТЕКА
      <span class="color-gray">{{ salons.length }}</span>
    </div>

    <div class="grid-row grid-row_sm mt-16">
      <div class="grid-col grid-col_full">
        <div class="form-group _icon-right">
          <input
            name="search"
            type="text"
            placeholder="Введите адрес или метро"
            class="form-field"
            v-model="inputFilter"
          />
          <div class="form-group__icon form-group__icon_right">
            <div class="btn">
              <Icon iconName="icon-search" className="icon-16" />
            </div>
          </div>
        </div>
      </div>

      <div class="grid-col">
        <div
          class="toggle-action border-radius-md border-stroke-dark-soft d-flex"
        >
          <div
            class="toggle-action__button btn"
            :class="{ 'is-active': activeEl === 1 }"
            @click="activeEl = 1"
          >
            <Icon iconName="icon-dots-list" className="icon-20" />
          </div>

          <div
            class="toggle-action__button btn"
            :class="{ 'is-active': activeEl === 2 }"
            @click="activeEl = 2"
          >
            <Icon iconName="icon-map-marker" className="icon-20" />
          </div>
        </div>
      </div>
    </div>

    <div v-show="activeEl === 1">
      <div v-show="this.filterSalons.length === 0">
        Нет салонов по вашему запросу
      </div>
      <div v-show="this.filterSalons.length !== 0" class="availability-table">
        <div class="py-16 border-bottom-stroke-dark-soft d-md-none">
          <div class="grid-row grid-row_md color-gray">
            <div class="grid-col grid-col_full">Магазин</div>
            <div class="availability-table__time grid-col">Можно забрать</div>
            <div class="availability-table__button grid-col"></div>
          </div>
        </div>

        <div
          v-for="(salon, index) in this.filterSalons.slice(0, this.countMore)"
          :key="index"
          class="py-16 border-bottom-stroke-dark-soft"
        >
          <div class="grid-row grid-row_md d-flex_middle d-flex_md-wrap">
            <div class="availability-table__adress grid-col grid-col_full">
              <div class="fw-medium">
                {{ salon.NAME }} {{ salon.METRO_NAME }}
              </div>
              <div class="d-flex mt-4 d-flex_middle">
                <div
                  class="adress__metro mr-4"
                  :style="'background-color: #' + salon.METRO_COLOR"
                ></div>
                <div class="fs-14">{{ salon.METRO_NAME }}</div>
              </div>
              <div class="mt-4 color-gray fs-14">
                {{ salon.ADDRESS }} <br />
                {{ salon.HOURS }}
              </div>
              <div
                v-if="salon.DISTANCE"
                class="d-flex mt-4 d-flex_middle color-tertiary"
              >
                <Icon iconName="icon-location-arrow" className="icon-16 mr-8" />
                <div class="fs-14">{{ salon.DISTANCE }} км</div>
              </div>
            </div>

            <div class="availability-table__time grid-col fs-14">
              Через 15 минут
            </div>
            <div class="availability-table__button grid-col">
              <button
                class="btn color-primary hover-color-hover-primary reserve-checkout"
                :data-offer="offerId"
                :data-salon="salon.ID"
              >
                Зарезервировать
              </button>
            </div>
          </div>
        </div>

        <div
          class="mt-32 d-flex d-flex_center"
          v-show="countMore < this.filterSalons.length"
        >
          <div
            class="btn btn_lg btn_stroke-dark-soft btn_px-lg border-radius-md"
            type="button"
            @click="
              () => {
                countMore += 5;
              }
            "
          >
            Показать еще
          </div>
        </div>
      </div>
    </div>

    <div v-show="activeEl === 2">
      <div :id="mapId" class="availability-map mt-16 border-radius-lg"></div>
    </div>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import axios from "axios";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";

export default {
  name: "Availability",
  components: {
    Icon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    mapId: {
      type: String,
      default: "availability-yandex-map",
    },
  },
  data() {
    return {
      activeEl: 1,
      inputFilter: "",
      latitude: undefined,
      longitude: undefined,
      salons: [],
      offerId: 0,
      countMore: 5,
      filterSalons: [],
    };
  },
  mounted() {
    if (!window.initYandexMap) {
      window.initYandexMap = true;
      window.addScript(window.ymapsSrc, function () {});
    }
    document.addEventListener("get-salon-event", async (event) => {
      this.offerId = event.detail.offerId;
      this.getSalonsRequest(event.detail.offerId);
    });

    setTimeout(() => {
      ymaps.ready(() => {
        window.yaMapId = new ymaps.Map(this.mapId, {
          center: [55.76, 37.64],
          zoom: 10,
          controls: [],
        });
      });
    }, 500);

    setTimeout(() => {
      ymaps.ready(() => {
        const productStore = useProductStore();
        let offersCount = Object.keys(productStore.offers).length;

        if (offersCount === 1 || productStore.selectedOfferId !== null) {
          this.offerId = productStore.getSelectedOffer.id;
          this.getSalonsRequest(productStore.getSelectedOffer.id);
        }
      });
    }, 1000);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        },
        null,
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    }
  },
  methods: {
    getSalonsRequest(offerId) {
      this.countMore = 5;
      axios
        .get(
          "/bitrix/services/main/ajax.php?mode=ajax&c=orteka:catalog.element&action=getAvailable",
          {
            params: {
              offerId: offerId,
              userLatitude: this.latitude,
              userLongitude: this.longitude,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            this.salons = response.data.data;
            this.getSalons();
          }
        });
    },
    getSalons() {
      let filterSalons = [];

      // Итерируемся по массиву вместо объекта
      for (let salon of this.salons) {
        if (this.inputFilter.length !== 0) {
          let search = this.inputFilter.toLowerCase();
          if (
            salon?.ADDRESS?.length > 1 &&
            salon?.ADDRESS?.toLowerCase().indexOf(search) !== -1
          ) {
            filterSalons.push(salon);
            continue;
          }

          if (
            salon?.METRO_NAME?.length > 1 &&
            salon?.METRO_NAME?.toLowerCase().indexOf(search) !== -1
          ) {
            filterSalons.push(salon);
          }
        } else {
          filterSalons.push(salon);
        }
      }
      if (filterSalons.length === 0) {
        if (window.yaMapId) {
          window.yaMapId.geoObjects.removeAll();
        }
      } else {
        window.yaMapId.setCenter([
          filterSalons[0].GEO_LAT,
          filterSalons[0].GEO_LON,
        ]);
        window.yaMapId.geoObjects.removeAll();
        filterSalons.forEach((el) => {
          let placemark = new ymaps.Placemark(
            [el.GEO_LAT, el.GEO_LON],
            {
              balloonContent: `<div class="baloon bg-white fs-14 pt-20 px-16 pb-16 border-radius-md">
    <div class="grid-row grid-row_md d-flex_middle">
      <div class="grid-col grid-col_full">
        <div class="fw-medium">${el.NAME} ${el.METRO_NAME || ""}</div>
      </div>
    </div>
    <div>${el.ADDRESS}</div>
    <div class="mt-8">Срок хранения резерва: 6 дней</div>

    <div class="mt-8"><span class="color-gray">График работы :</span> ${
      el.HOURS
    }</div>

    ${
      el.DISTANCE
        ? `<div class="mt-8"><span class="color-gray">Расстояние:</span> ${el.DISTANCE} км</div>`
        : ""
    }

    <div class="mt-8">
      <span class="color-gray">Можно забрать:</span>
      <span class="color-primary fw-medium">через 15 минут</span>
    </div>

    <div class="mt-16">
      <button
        class="btn btn_md border-radius-md fs-14 btn_stroke-primary w-100 reserve-checkout"
        data-offer="${this.offerId}"
        data-salon="${el.ID}"
      >
        Зарезервировать
      </button>
    </div>
  </div>
`,
            },
            {
              iconLayout: "default#image",
              iconImageHref: "/local/templates/orteka_desktop/img/pin.svg",
              iconImageSize: [50, 50],
              iconImageOffset: [-20, -45],
            }
          );
          window.yaMapId.geoObjects.add(placemark);
        });
      }

      this.filterSalons = filterSalons;
    },
  },
};
</script>

<style lang="scss">
@import "./availability.scss";
</style>
